export const GET_ANNOTATIONS_PENDING = 'GET_ANNOTATIONS_PENDING'
export const GET_ANNOTATIONS_SUCCESSFUL = 'GET_ANNOTATIONS_SUCCESSFUL'
export const GET_ANNOTATIONS_ERROR = 'GET_ANNOTATIONS_ERROR'

export const START_ANNOTATION = 'START_ANNOTATION'
export const STAGE_ANNOTATION = 'STAGE_ANNOTATION'
export const SELECT_ANNOTATION = 'SELECT_ANNOTATION'
export const DESELECT_ANNOTATION = 'DESELECT_ANNOTATION'

export const CREATE_ANNOTATION_PENDING = 'CREATE_ANNOTATION_PENDING'
export const CREATE_ANNOTATION_SUCCESS = 'CREATE_ANNOTATION_SUCCESS'
export const CREATE_ANNOTATION_ERROR = 'CREATE_ANNOTATION_ERROR'
export const CREATE_ANNOTATION_FORBIDDEN = 'CREATE_ANNOTATION_FORBIDDEN'

export const UPDATE_ANNOTATION_PENDING = 'UPDATE_ANNOTATION_PENDING'
export const UPDATE_ANNOTATION_SUCCESS = 'UPDATE_ANNOTATION_SUCCESS'
export const UPDATE_ANNOTATION_ERROR = 'UPDATE_ANNOTATION_ERROR'

export const DELETE_ANNOTATION_PENDING = 'DELETE_ANNOTATION_PENDING'
export const DELETE_ANNOTATION_SUCCESS = 'DELETE_ANNOTATION_SUCCESS'
export const DELETE_ANNOTATION_ERROR = 'DELETE_ANNOTATION_ERROR'

export const DELETE_ROOT_COMMENT_SUCCESS = 'DELETE_ROOT_COMMENT_SUCCESS'

export const HOVER_ANNOTATION = 'HOVER_ANNOTATION'

export const GENERATE_MERGED_PDF_PENDING = 'GENERATE_MERGED_PDF_PENDING'
export const GENERATE_MERGED_PDF_SUCCESSFUL = 'GENERATE_MERGED_PDF_SUCCESSFUL'
export const GENERATE_MERGED_PDF_DONE = 'GENERATE_MERGED_PDF_DONE'
export const GENERATE_MERGED_PDF_ERROR = 'GENERATE_MERGED_PDF_ERROR'

export const MERGED_PDF_READY = 'MERGED_PDF_READY'
export const MERGED_PDF_TIMED_OUT = 'MERGED_PDF_TIMED_OUT'

export const ALERT_ERROR = 'ALERT_ERROR'
